export enum RoutePaths {
  QUANT_ALERTS = "/quant/alerts",
  QUANT_CONSUMERS = "/quant/consumers",
  QUANT_ACCOUNTS = "/quant/accounts",
  QUANT_DASHBOARD = "/quant/dashboard",
  HOME = "/",
  SIGN_IN = "/sign-in",
  HOMEPAGE = "/homepage",
  USER_MANAGEMENT = "/administration/user-management",
  PERMISSION_MANAGEMENT = "/administration/permission-management",
  ANNOUNCEMENTS = "/administration/user-interaction/events-and-updates/announcements",
  UPCOMING_EVENTS = "/administration/user-interaction/events-and-updates/upcoming-events",
  WEEKLY_UPDATES = "/administration/user-interaction/events-and-updates/updates",
  STATEMENTS = "/administration/investor-management/statements",
  REPORTS = "/administration/investor-management/reports",
  STATEMENT_TYPE = "/administration/investor-management/statement-type",
  REPORT_TYPE = "/administration/investor-management/report-type",
  EXPECTED_CONVERSION = "/administration/settings/expected-conversion",
  CONVERSION_GRADING = "/administration/settings/conversion-grading",
  NOTIFICATION_SETTINGS = "/administration/settings/notifications",
  HR_EMPLOYEE = "/hr/employee",
  HR_EMPLOYEE_COMPENSATION = "/hr/employee-compensation",
  HR_FINANCIAL_REPORT = "/hr/financial-report",
  HR_POINT_SYSTEM_QUANT_FUND_TIER = "/hr/point-system/quant/fund-tier",
  HR_POINT_SYSTEM_QUANT_POINTS = "/hr/point-system/quant/points-assignment",
  HR_POINT_SYSTEM_QUANT_PERFORMANCE = "/hr/point-system/quant/performance",
  HR_POINT_SYSTEM_QUANT_DISTRIBUTION = "/hr/point-system/quant/distribution",
  HR_POINT_SYSTEM_VENTURE_POINTS = "/hr/point-system/venture/points-assignment",
  HR_POINT_SYSTEM_VENTURE_PERFORMANCE = "/hr/point-system/venture/performance",
  HR_POINT_SYSTEM_VENTURE_DISTRIBUTION = "/hr/point-system/venture/distribution",
  HR_POINT_SYSTEM_CAPITAL_FORMATION_TIER = "/hr/point-system/capital-formation/tier",
  HR_POINT_SYSTEM_CAPITAL_FORMATION_DISTRIBUTION = "/hr/point-system/capital-formation/distribution",
  HR_EMPLOYEE_LEAVE = "/hr/employee-leave",
  HR_HOLIDAY_CALENDAR = "/hr/holiday-calendar",
  HR_LIBRARY_DOCUMENT_LIST = "/administration/libraries/hr/document-list",
  INFRASTRUCTURE_DASHBOARD = "/infrastructure/dashboard",
  INFRASTRUCTURE_ACCOUNTS = "/infrastructure/accounts",
  INFRASTRUCTURE_SYSTEM_TASKS = "/infrastructure/system-tasks",
  CAPITAL_FORMATION_DASHBOARD = "/capital-formation/dashboard",
  CAPITAL_FORMATION_LEAD_MAPPING = "/capital-formation/lead-mapping",
  CAPITAL_FORMATION_LEAD_REPORTING = "/capital-formation/lead-reporting",
  CAPITAL_FORMATION_KPI_PERFORMANCE = "/capital-formation/kpi-performance",
  CAPITAL_FORMATION_CI_RESOURCES = "/capital-formation/ci-resources",
  CAPITAL_FORMATION_SNAPSHOTS = "/capital-formation/snapshots",
  CAPITAL_FORMATION_FUND_RAISING = "/capital-formation/fundraising",
  CAPITAL_FORMATION_CRST_INVESTOR_DATABASE = "/capital-formation/crst-investor-database",
  CAPITAL_INTRODUCER_PROFILES = "/capital-formation/capital-introducer/profiles",
  CAPITAL_INTRODUCER_PAYOUTS = "/capital-formation/capital-introducer/payouts",
  CAPITAL_INTRODUCER_REPORTS = "/capital-formation/capital-introducer/reports",
  CAPITAL_INTRODUCER_KPI_REPORT = "/capital-formation/capital-introducer/kpi-report",
  INVESTMENT_DATABASE = "/capital-formation/investor-database",
  INVESTMENT_LIBRARY_DOCUMENT = "/administration/libraries/investment/document-list",
  INVESTMENT_LIBRARY_PRODUCT_FUND = "/administration/libraries/investment/product-fund",
  INVESTMENT_LIBRARY_TAG = "/administration/libraries/investment/tag",
  INVESTMENT_LIBRARY_NOTE_TYPE = "/administration/libraries/investment/note-type",
  INVESTMENT_LIBRARY_SOURCE_EXCHANGE = "/administration/libraries/investment/transfer-source",
  FINANCE_DISTRIBUTION_MODELING = "/finance/venture/distribution-model",
  FINANCE_DASHBOARD = "/finance/dashboard",
  FINANCE_ASSETS_FIREBLOCKS = "/finance/assets/fireblocks",
  FINANCE_ASSETS_EXCHANGE = "/finance/assets/exchange-assets",
  FINANCE_ASSETS_EXCHANGE_ACCOUNTS = "/finance/assets/exchange-accounts",
  FINANCE_ASSETS_EXCHANGE_TYPE = "/finance/assets/exchanges",
  FINANCE_ASSETS_LEGAL_ENTITIES = "/finance/assets/legal-entities",
  FINANCE_ASSETS_BANK_ACCOUNTS = "/finance/assets/bank-accounts",
  FINANCE_ASSETS_SNAPSHOTS = "/finance/assets/snapshots",
  FINANCE_CAPITAL_MOVEMENT = "/finance/capital-control/capital-movement",
  FINANCE_CAPITAL_MOVEMENT_DIVIDEND = "/finance/capital-control/capital-movement-dividend",
  FINANCE_INTRA_GROUP_LOANS = "/finance/capital-control/intra-group-loans",
  PRODUCT_FUND_SERIES = "/finance/capital-control/product-fund-series",
  REPORTING = "/finance/capital-control/investor-reporting",
  VENTURE_DASHBOARD = "/venture/dashboard",
  VENTURE_PROJECT_PROFILE = "/venture/project-profiles",
  VENTURE_PORTFOLIO_CONTROL = "/venture/portfolio-control",
  VENTURE_VALUATION_CONTROL = "/venture/valuation-control",
  VENTURE_ASSET_ATTRIBUTION = "/venture/attributions-and-exits",
  VENTURE_TGE_CALENDAR = "/venture/tge-calendar",
  VENTURE_MODELING_TOKEN_MODELING = "/venture/modeling/token-modeling",
  VENTURE_MODELING_VESTING_MODELING = "/venture/modeling/vesting-modeling",
  VENTURE_KPI = "/venture/kpi",
  VENTURE_SNAPSHOTS = "/venture/snapshots",
  VENTURE_CONTACT = "/venture/contact-database",
  VENTURE_LIBRARY_CONTACT_TYPE = "/administration/libraries/venture/contact-type",
  VENTURE_LIBRARY_INVESTMENT_METHOD = "/administration/libraries/venture/investment-method",
  VENTURE_LIBRARY_BLOCKCHAIN_LIST = "/administration/libraries/venture/blockchain-list",
  VENTURE_LIBRARY_ORIGINATION_SOURCE = "/administration/libraries/venture/origination-source",
  VENTURE_LIBRARY_SECTOR = "/administration/libraries/venture/sector",
  VENTURE_LIBRARY_TAGS = "/administration/libraries/venture/tags",
  VENTURE_LIBRARY_NOTE_TYPE = "/administration/libraries/venture/note-type",
  VENTURE_LIBRARY_DOCUMENT_LIST = "/administration/libraries/venture/document-list",
  WESTEROS_CLIENT_DATABASE = "/westeros/clients",
  WESTEROS_LIBRARY_SERVICE = "/administration/libraries/westeros/service",
  WESTEROS_LIBRARY_NOTE_TYPE = "/administration/libraries/westeros/note-type",
  WESTEROS_LIBRARY_DOCUMENT_LIST = "/administration/libraries/westeros/document-list",
  WESTEROS_LIBRARY_TAGS = "/administration/libraries/westeros/tags",
  WESTEROS_PWM_PROFILE = "/westeros/pwm/profile",
  WESTEROS_PWM_TRADING = "/westeros/pwm/trading-volume",
  WESTEROS_PWM_EXCHANGE = "/westeros/pwm/exchanges",
  WESTEROS_PWM_STRATEGY = "/westeros/pwm/strategies",
  WESTEROS_PWM_PROFILE_REPORT = "/westeros/pwm/profile-report",
  WESTEROS_PWM_LIBRARY_DOCUMENT_LIST = "/administration/libraries/westeros/pwm/document-list",
  WESTEROS_PWM_LIBRARY_NOTE_TYPE = "/administration/libraries/westeros/pwm/note-type",
  WESTEROS_PWM_LIBRARY_EXCHANGE_ITEM = "/administration/libraries/westeros/pwm/exchange-list",
  WESTEROS_PWM_LIBRARY_STRATEGY_ITEM = "/administration/libraries/westeros/pwm/strategy-list",
  ADVISORY_PROJECT = "/westeros/allocation/project",
  ADVISORY_BUYER = "/westeros/allocation/buyer",
  ADVISORY_PURCHASE = "/westeros/allocation/purchase",
  ADVISORY_TRANCHE = "/westeros/allocation/tranche",
  ADVISORY_EXIT_PLAN = "/westeros/allocation/exit-plan",
  ADVISORY_DISTRIBUTION = "/westeros/allocation/distribution",
  ADVISORY_REPORT = "/westeros/allocation/report",
  ADVISORY_LIBRARY_FIREBLOCKS_WALLET = "/administration/libraries/allocation/fireblocks-wallet",
  EMAILS = "/systems/email-system",
  EMAIL_TEMPLATES = "/systems/email-templates",
  EMAIL_SEND_EMAIL = "/systems/email-system/send-email",
  SYSTEM_TASK_MANAGEMENT_TASK = "/systems/task-system/task",
  SYSTEM_TASK_MANAGEMENT_RECURRING_TASK = "/systems/task-system/recurring-task",
  SYSTEM_TASK_MANAGEMENT_REMIND = "/systems/task-management/reminder",
  SYSTEM_TASK_MANAGEMENT_TASK_REPORTING = "/systems/task-management/task-reporting",
  SYSTEM_TASK_MANAGEMENT_TASK_TYPE = "/administration/libraries/task-management/task-type",
  SYSTEM_TASK_MANAGEMENT_NOTE_TYPE = "/administration/libraries/task-management/note-type",
  SYSTEM_TASK_MANAGEMENT_REMIND_TYPE = "/administration/libraries/task-management/remind-type",
  USER_CAPITAL_INTRODUCER_MY_INFO = "/capital-introducer/my-info",
  USER_CAPITAL_INTRODUCER_RESOURCES = "/capital-introducer/resources",
  USER_CAPITAL_INTRODUCER_REPORTS = "/capital-introducer/reports",
  USER_CAPITAL_INTRODUCER_PAYOUTS = "/capital-introducer/payouts",
  USER_INVESTOR_MY_INFO = "/my-info",
  USER_INVESTOR_DASHBOARD = "/performance",
  USER_INVESTOR_CAPITAL_MOVEMENT = "/capital-movement",
  USER_INVESTOR_REPORTS = "/reports",
  USER_INVESTOR_STATEMENTS = "/statements",
  AI_AGENT_LEADS = "/ai-agent/leads",
  USER_EMPLOYEE_DASHBOARD = "/dashboard",
  NOT_FOUND = "/not-found",
  WILDECARD = "*",
}
